<template lang="pug">
    footer
        .container
            .block(v-for="menu in blocks" :class="menu.key")
                nav#footer-menu(v-if="menu.menuItems && menu.menuItems.length")
                    tree-menu(:items="menu.menuItems" :max-depth="2" :depth="2" :allow-multiple-active-items="true" :delay="100")
</template>

<script>

import _ from 'lodash'
import { mapGetters } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default{
    name: 'Footer',
    computed: {
        blocks() {

            let blocks = []

            this.menus.forEach(menu => {
                if (['footer-menu1', 'footer-menu2', 'footer-menu3', 'footer-menu4'].includes(menu.key)) {
                    blocks.push(menu)
                }
            })

            return blocks

            // const menu = this.menus.find(menu => menu.key === 'footer-menu')
            // let items = _.get(menu, 'menuItems') || []
            // items = _.cloneDeep(items)

            // if (items.length) {
            //     return NestedSet.createTree(items)
            // }

            // return items
        },
        ...mapGetters({
            menus: 'menus',
            config: 'config',
        })
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins";
    @import '~@/assets/sass/variables';

    footer
        background-color: $lightgray
        color: #ffffff
        position: relative
        margin-top: 50px
        .block ::v-deep
            display: inline-block
            width: calc(100%/4)
            margin: 30px 0


            +tablet-only
                padding-left: 15px
                width: calc(100%/2)
            +mobile
                width: 100%
                padding-left: 10px
                margin: 10px 0


            nav#footer-menu
                a
                    color: #ffffff
                ul
                    & > li
                        a
                            color: #222
                            font-weight: 600
                            font-size: 13px
                            display: block
                            padding: 4px 0px
                            line-height: 20px
                            &:hover
                                color: $primary
                    +desktop
                        & > li
                            text-transform: uppercase
                            &:last-child
                                border-right: none
                            a:

                            &.visible
                                a

                                //background-color: #666666
        div#va-footer
            font-size: .8rem
            padding: 4px
            text-align: center
            background-color: rgba(0, 0, 0, .2)
            +desktop
                background-color: initial
                font-size: .9rem
                position: absolute
                bottom: 100%
                color: #4c4c4c
                width: 100%
                text-align: center
</style>
